<template>
    <div class="user">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10">
                    <b-row>
                        <b-col cols="12" md="4" class="mb-3">
                            <b-card>
                                <template #header>
                                    <span class="font-weight-bold">一般課程</span>
                                </template>
                                <b-list-group flush>
                                    <b-list-group-item button @click="_go('/order')">訂單</b-list-group-item>
                                    <b-list-group-item button @click="_go('/myRegistration')">報名表</b-list-group-item>
                                    <b-list-group-item button @click="_go('/favorite')">課程收藏</b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-col>
                        <b-col cols="12" md="4" class="mb-3">
                            <b-card>
                                <template #header>
                                    <span class="font-weight-bold">營隊</span>
                                </template>
                                <b-list-group flush>
                                    <b-list-group-item button @click="_go('/campRegistration')">報名表</b-list-group-item>
                                    <b-list-group-item button @click="_go('/campOrder')">
                                        訂單總覽
                                        <b-badge v-if="hasCampTodo" pill variant="danger" class="unpaid-dot ml-1"
                                            :title="campTodoTitle">&nbsp;</b-badge>
                                    </b-list-group-item>
                                    <!-- 報價單無營隊收藏功能，暫時隱藏
                                    <b-list-group-item button @click="_go('/campFavorite')">營隊收藏</b-list-group-item>
                                    -->
                                    <b-list-group-item button @click="_go('/campRelations')">家庭成員</b-list-group-item>
                                    <b-list-group-item button @click="_go('/memberNotification')">
                                        通知中心
                                        <b-badge v-if="unreadNotificationCount" pill variant="danger" class="ml-1">{{ unreadNotificationCount }}</b-badge>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-col>
                        <b-col cols="12" md="4" class="mb-3">
                            <b-card>
                                <template #header>
                                    <span class="font-weight-bold">帳號</span>
                                </template>
                                <b-list-group flush>
                                    <b-list-group-item button @click="_go('/profile')">基本資料</b-list-group-item>
                                    <b-list-group-item button @click="_go('/accountSecurity')">帳號安全</b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import nacUser from '@/components/nacUser.vue';

export default {
    components: { nacUser },
    data() {
        return {
            title: '會員中心',
        };
    },
    computed: {
        hasCampTodo() {
            return this.$store.getters['campUnpaidOrder/hasCampTodo'];
        },
        campTodoTitle() {
            const s = this.$store.state.campUnpaidOrder;
            const parts = [];
            if (s.hasUnpaid) parts.push('待付款訂單');
            if (s.hasUnpaidSurcharge) parts.push('補收款待繳');
            if (s.hasPendingRefund) parts.push('退費待處理');
            return parts.length ? `有${parts.join('、')}` : '';
        },
        unreadNotificationCount() {
            return this.$store.state.memberNotification.unreadCount;
        },
    },
    methods: {
        logout() {
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
    },
};
</script>
<style scoped>
.unpaid-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    padding: 0;
    line-height: 6px;
    overflow: hidden;
    vertical-align: middle;
}
</style>
